import { z } from "zod";

/** A small table of numbers per row, e.g. meetings booked and held per seller. */
export const METRIC_TABLE_PART = "metric-table" as const;
export const METRIC_TABLE_PART_TYPE = `data-${METRIC_TABLE_PART}` as const;

const cellSchema = z.union([z.string(), z.number(), z.null()]);

export const metricTableColumnSchema = z.object({
  key: z.string().min(1).max(40),
  label: z.string().min(1).max(60),
  /** `member` cells carry a Graftus member id on the row and render as a member pill. */
  kind: z.enum(["text", "number", "member"]).optional(),
});

export const metricTableRowSchema = z.object({
  cells: z.record(z.string().min(1).max(40), cellSchema),
  /** Graftus member id (salesTeamsMembers) the row is about, for the pill. */
  memberId: z.string().min(1).max(64).optional(),
});

export const metricTableV1Schema = z.object({
  version: z.literal(1),
  title: z.string().max(120).optional(),
  /** Inclusive calendar dates the numbers cover. */
  period: z
    .object({
      from: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
      to: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    })
    .optional(),
  columns: z.array(metricTableColumnSchema).min(1).max(12),
  rows: z.array(metricTableRowSchema).max(200),
  /** One line under the table: a floor ("minst"), who is not linked, and so on. */
  note: z.string().max(400).optional(),
  /** The system the numbers come from, for the icon. */
  source: z
    .object({
      name: z.string().min(1).max(60),
      domain: z.string().min(1).max(120).optional(),
    })
    .optional(),
});

export type MetricTableV1 = z.infer<typeof metricTableV1Schema>;
export type MetricTableColumn = z.infer<typeof metricTableColumnSchema>;
export type MetricTableRow = z.infer<typeof metricTableRowSchema>;
